export default "/images/ru-room-tour-600.png?0ec9870f6dd21056bbfd16ef928b5661";